module.exports = __webpack_public_path__ + "static/media/signage-indoor-img51.0ef1688a.jpg";